import {
  ButtonProps,
  CSSObject,
  IconButton,
  styled,
  colors,
} from '@mui/material';

export const IconButtonStyledOutlined = styled(IconButton)<{
  variant?: Exclude<ButtonProps['variant'], 'text'>;
}>(({ theme, variant, color }) => {
  const overrides: CSSObject = {};
  const colorAsVariant =
    color === 'inherit' || color === 'default' ? 'primary' : color;

  if (variant === 'outlined') {
    overrides.borderColor = colorAsVariant
      ? theme.palette[colorAsVariant].main
      : colors.grey[300];
  }

  return {
    ...overrides,
  };
});
